import { BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';

import { Breadcrumb } from './breadcrumbs.types';

@Injectable()
export class BreadcrumbsService {
  private readonly subject = new BehaviorSubject<readonly Breadcrumb[]>([]);
  public readonly breadcrumbs$ = this.subject.asObservable();

  public update(breadcrumbs: readonly Breadcrumb[]): void {
    this.subject.next(breadcrumbs);
  }

  public clear(): void {
    this.subject.next([]);
  }
}
